import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BYPASS_ROUTE_GUARD } from '@domgen/dgx-fe-common';
import { LoggingService } from '@domgen/dgx-fe-logging';
import { Observable, of } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { CheckoutFacade } from '../../+state/checkout.facade';

export const hasCompletedAllSelectedQuotesGuard: CanActivateFn = (
  route
): Observable<boolean> => {
  const bypassRouteGuard = inject(BYPASS_ROUTE_GUARD);
  const checkoutFacade = inject(CheckoutFacade);
  const loggingService = inject(LoggingService);
  const router = inject(Router);

  loggingService.debug('hasCompletedAllSelectedQuotesGuard', 'Start');
  const redirectTo: string = route.data?.['redirectTo'] ?? '/';

  if (bypassRouteGuard) {
    loggingService.debug('hasCompletedAllSelectedQuotesGuard', 'Success');
    return of(true);
  }

  return checkoutFacade.hasCompletedAllSelectedQuotes$.pipe(
    first(),
    tap((canActivate: boolean) => {
      if (!canActivate) {
        loggingService.debug(
          'hasCompletedAllSelectedQuotesGuard',
          'Redirect',
          redirectTo
        );
        router.navigate([redirectTo], {
          queryParams: route.queryParams,
          replaceUrl: true,
        });

        return;
      }

      loggingService.debug('hasCompletedAllSelectedQuotesGuard', 'Success');
    })
  );
};
